import client from "@/lib/api";
import { toast } from "sonner";

// Download the government-grade CAD Call Event Report PDF for a call (by id or CC#).
export async function downloadCallEventPdf(ref, label = ref) {
  try {
    const r = await client.get(`/call-event/${encodeURIComponent(ref)}/report.pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url; a.download = `CallEvent_${label}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
    toast.success(`Call Event Report ${label} downloaded`);
    return true;
  } catch (e) {
    const txt = e.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : e.response?.data?.detail;
    toast.error(txt || "PDF export failed");
    return false;
  }
}
